export const AUTH_PORTAL_RETURN_URL_KEY = 'insightAuthPortalReturnUrl';

export function isAuthPortalTrampolinePath(pathname = '') {
  return /(?:^|\/)user-profile(?:\/|$)/.test(pathname);
}

export function dashboardUrlFromTrampoline(origin, pathname = '') {
  const trampolineIndex = pathname.indexOf('/user-profile');
  const appRoot = trampolineIndex >= 0 ? pathname.slice(0, trampolineIndex) : '';
  const prefix = appRoot.endsWith('/') ? appRoot : `${appRoot}/`;
  return `${origin}${prefix}mspHome/dashboard`;
}

/**
 * OC return URL after Update Profile / account settings.
 * Dashboard pages are stored and reused. `/user-profile*` trampolines must not
 * be used as redirectUrl or OC sends the user back into AuthPortalRedirect.
 */
export function resolveAuthPortalReturnUrl(location, storage) {
  const { origin = '', pathname = '', search = '', hash = '' } = location || {};
  if (isAuthPortalTrampolinePath(pathname)) {
    try {
      const stored = storage?.getItem?.(AUTH_PORTAL_RETURN_URL_KEY);
      if (stored) return stored;
    } catch {
      // Private mode / quota.
    }
    return dashboardUrlFromTrampoline(origin, pathname);
  }
  const currentUrl = `${origin}${pathname}${search}${hash}`;
  if (!currentUrl) return '';
  try {
    storage?.setItem?.(AUTH_PORTAL_RETURN_URL_KEY, currentUrl);
  } catch {
    // Private mode / quota — still return the live URL.
  }
  return currentUrl;
}
